module.exports = __webpack_public_path__ + "img/lessnegative.97045dda.svg";